import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateMentorshipProgramModulesMutationVariables = Types.Exact<{
  updates: Types.MentorshipProgramModule_Updates;
}>;


export type UpdateMentorshipProgramModulesMutation = { __typename?: 'mutation_root', update_mentorshipProgramModule_many?: Array<{ __typename?: 'mentorshipProgramModule_mutation_response', returning: Array<{ __typename?: 'mentorshipProgramModule', id: number, name: string, order: number, content: string, duration?: number | null, createdAt: any }> } | null> | null };


export const UpdateMentorshipProgramModulesDocument = gql`
    mutation updateMentorshipProgramModules($updates: mentorshipProgramModule_updates!) {
  update_mentorshipProgramModule_many(updates: [$updates]) {
    returning {
      id
      name
      order
      content
      duration
      createdAt
    }
  }
}
    `;
export type UpdateMentorshipProgramModulesMutationFn = Apollo.MutationFunction<UpdateMentorshipProgramModulesMutation, UpdateMentorshipProgramModulesMutationVariables>;

/**
 * __useUpdateMentorshipProgramModulesMutation__
 *
 * To run a mutation, you first call `useUpdateMentorshipProgramModulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMentorshipProgramModulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMentorshipProgramModulesMutation, { data, loading, error }] = useUpdateMentorshipProgramModulesMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateMentorshipProgramModulesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMentorshipProgramModulesMutation, UpdateMentorshipProgramModulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMentorshipProgramModulesMutation, UpdateMentorshipProgramModulesMutationVariables>(UpdateMentorshipProgramModulesDocument, options);
      }
export type UpdateMentorshipProgramModulesMutationHookResult = ReturnType<typeof useUpdateMentorshipProgramModulesMutation>;
export type UpdateMentorshipProgramModulesMutationResult = Apollo.MutationResult<UpdateMentorshipProgramModulesMutation>;
export type UpdateMentorshipProgramModulesMutationOptions = Apollo.BaseMutationOptions<UpdateMentorshipProgramModulesMutation, UpdateMentorshipProgramModulesMutationVariables>;